import React from 'react';
import PropTypes from 'prop-types';
import { Box, InputBase, IconButton } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from '../styles';
import analytics from '../../../helper/analytics';
import tracker from '../../../constants/tracker';

function SearchMetric(props) {
	const { setSearchText, searchText, disabled } = props;
	const classes = useStyles();

	const handleSearch = (e) => {
		const value = e.target.value;
		setSearchText(value);
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.SEARCH_METRICS,
		});
	};

	const handleClearSearch = () => {
		setSearchText('');
	};

	return (
		<Box className={classes.table_search}>
			<Box className={classes.table_searchIcon}>
				<SearchIcon />
			</Box>
			<InputBase
				value={searchText}
				id="search-metric"
				onChange={handleSearch}
				placeholder="Search metric"
				classes={{ input: classes.table_input }}
				inputProps={{ 'aria-label': 'search' }}
				disabled={disabled}
			/>
			{searchText !== '' && (
				<Box className={classes.table_crossIcon}>
					<IconButton
						aria-label="Clear search"
						id="clear"
						onClick={handleClearSearch}
						sx={{
							'&:hover': { background: 'none', backgroundColor: 'transparent' },
						}}>
						<CloseIcon fontSize="medium" />
					</IconButton>
				</Box>
			)}
		</Box>
	);
}

SearchMetric.propTypes = {
	setSearchText: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	searchText: PropTypes.string,
};

export default SearchMetric;
